import { z } from 'zod';
import { BaseErrorSchema } from '../../../../shared/error.schema';
import { UserTypeSchema, UserStatusSchema, UserClassificationSchema, refineExternalMember } from '../../../../entities/user';
/**
 * Add Tenant User Request Schema
 * POST /api/v2/tenantuser
 * Creates a new user within a specific tenant organization.
 * The backend owns the initial status: users are always created 'inactive',
 * and only the invitation flow may move them to 'pending'.
 */ export const TenantUserInfoSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.email(),
    userTypes: z.array(UserTypeSchema),
    classification: UserClassificationSchema,
    externalOrganization: z.string().optional()
});
export const AddTenantUserRequestSchema = z.object({
    user: TenantUserInfoSchema,
    tenantId: z.string(),
    // If true, backend sends the invitation email and sets status to 'pending'
    sendInvitation: z.boolean().optional()
}).superRefine((data, ctx)=>{
    // External members: externalOrganization + elevated role required.
    refineExternalMember(ctx, data.user, {
        pathPrefix: [
            'user'
        ]
    });
});
/**
 * Tenant User Schema
 * Represents a user entity within a tenant
 */ export const TenantUserSchema = z.object({
    _id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.email(),
    department: z.string().optional(),
    userTypes: z.array(UserTypeSchema),
    status: UserStatusSchema,
    classification: UserClassificationSchema,
    externalOrganization: z.string().optional(),
    invitedAt: z.number().optional(),
    activatedAt: z.number().optional()
});
/**
 * Add Tenant User Response Schema
 * Returned on successful user creation
 * Contains the created tenant user object
 */ export const AddTenantUserResponseSchema = z.object({
    tenantUser: TenantUserSchema,
    // Present only when the request asked for an invitation. False means the
    // user was created but the email failed — retry via "Send Invitation".
    invitationSent: z.boolean().optional()
});
/**
 * Add Tenant User Error Schema
 * Returned when user creation fails
 */ export const AddTenantUserErrorSchema = BaseErrorSchema;

//# sourceMappingURL=add-tenant-user.schema.js.map